export const KNOWN_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',

  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',

  'yahoo.com',
  'yahoo.co.in',
  'yahoo.co.uk',
  'yahoo.ca',
  'ymail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'zoho.com',
  'zohomail.com',
  'rediffmail.com',
  'rediff.com',
  'gmx.com',
  'gmx.net',
  'gmx.de',
  'mail.com',
  'yandex.com',
  'yandex.ru',
  'tutanota.com',
  'tuta.io',
  'fastmail.com',
  'fastmail.fm',
  'web.de',
  'freenet.de',
  'orange.fr',
  'libero.it',
  'indiatimes.com',
  'sify.com',
  'vsnl.com',
  'bsnl.in',
  'qq.com',
  '163.com',
  '126.com',
  'yeah.net',
  'yahoo.co.jp',
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'softbank.ne.jp',
  'naver.com',
  'daum.net',
  'hanmail.net',
  'mail.ru',
  'bk.ru',
  'inbox.ru',
  'list.ru',
  'uol.com.br',
  'bol.com.br',
  'bigpond.com',
  'optusnet.com.au'
];
